import ResetPassword from "../../Components/ResetPassword/ResetPasswordPage"

export default function ResetPasswordPage(){
    return(
        <ResetPassword/>
    )
}